import microApps from './micro-app';

export default {
  // 不需要鉴权路由的path
  excludePath: [
    '/login',
    '/redirect',
    '/error',
    '/error/401',
    '/error/404'
  ],

  /**
   * @description: 微应用列表
   */
  microApps,
  microAppsActiveRules: microApps.map((item) => item.activeRule),

  useThreeModel: true,
};
